import * as React from 'react';
import { connect } from 'react-redux';
import { RedeemCode } from 'components/containers';
import { LayoutContainer } from 'theme'
import { IRootState } from 'store';
import { SubscriptionInfo } from 'components/containers/SubscriptionInfo';

export interface IAccountSettingsProps {

}

const mapStateToProps = (state: IRootState) => ({

});

const mapDispatchToProps = (dispatch) => ({

})

const AccountSettingsView: React.SFC<IAccountSettingsProps> = (props) => {
	return (
		<LayoutContainer>
			<SubscriptionInfo />
			<RedeemCode onCodeRedeemed={(r) => { /* Add Handler After Code is redeemed */ }} />
		</LayoutContainer>
	);
}


export const AccountSettings = connect(mapStateToProps, mapDispatchToProps)(AccountSettingsView)



// WEBPACK FOOTER //
// ./src/components/presentational/views/AccountSettings/index.tsx